import React from "react";
import { PaperTabLayout } from "frontend/src/ui/paper-tab-layout";
import { BusinessOwnerLayout } from "frontend/src/pages/layouts";
import { FileUploadTab } from "./file-upload-tab";
import { UserTrackTab } from "./user-tracks-tab";
import { usePageModel } from "./model.new";
var Page = function () {
    var _a, _b;
    var _c = usePageModel(), advertisements = _c.advertisements, play = _c.play, editedAdvertisement = _c.editedAdvertisement, onFileFormSubmit = _c.onFileFormSubmit;
    var tabs = [
        {
            label: "Загруженные файлы",
            node: (React.createElement(UserTrackTab, { advertisements: advertisements.data, onTrackPlay: play })),
        },
        {
            label: "Добавить новый",
            node: (React.createElement(FileUploadTab, { onFileSubmit: onFileFormSubmit, fileErrors: editedAdvertisement.errors, fileTitle: editedAdvertisement.title.value, hasUploadedFile: editedAdvertisement.hasUploadedFile, isSubmitting: false, onFileInputChange: editedAdvertisement.file.onChange, onFileTitleChange: editedAdvertisement.title.set, onRightsConfirmedChange: editedAdvertisement.rightsConfirmed.set, rightsConfirmed: editedAdvertisement.rightsConfirmed.value, uploadedFileTitle: (_b = (_a = editedAdvertisement.file.value) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : "" })),
        },
    ];
    return (React.createElement(PaperTabLayout, { tabs: tabs, keepMounted: true, mobileVariant: "scrollable" }));
};
export var AdvertisementsPage = function () {
    return (React.createElement(BusinessOwnerLayout, null,
        React.createElement(Page, null)));
};
